import React from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { useSearchParams } from "react-router-dom";
import "./MasterDataTable.css";
import { Editicon, Deleteicon } from "../../../../Components/IconComponents";
import { useKeycloak } from "@react-keycloak/web";
import Table from "../../../../Components/UiComponents/Table/Table";
import { Modal, Button } from "react-bootstrap";
import Moment from "react-moment";
import ResourceTypeDetails from "../../../../Components/UiComponents/ResourceTypeDetails/ResourceTypeDetails";
import ModalResourceType from "../../../../Components/UiComponents/ModalResourceType/ModalResourceType";
import { getData, putDataWithBody } from "../../../../Services/Services";
import {
  masterDataAttrTypeListURL,
  getConfigsByCategoryName,
  deleteConfig,
  getThemeURL,
} from "../../../../Services/EndPoints";
import SelectComponent from "../../../../Components/UiComponents/SelectComponent/SelectComponent";
import { Filter as FilterIcon } from "lucide-react";
import Loader from "react-spinner-loader";
import { toast, ToastContainer } from "react-toastify";
import Confirmpopup from "../../Common/ConfirmPopup/Confirmpopup";
import StatusHandler from "../../Common/StatusHandler/StatusHandler";
import { useTranslation } from "react-i18next";
const MasterDataTable = forwardRef((props, ref) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [stateId, setStateId] = useState(null);
  const { keycloak } = useKeycloak();
  const [userdata, setUserdata] = useState([]);
  const [loader, setLoader] = useState(false);
  const qs = require("qs");
  const [masterTypeData, setMasterTypeData] = useState([]);
  const [selectedConfigId, setSelectedConfigId] = useState(null);
  const [isShow, invokeModal] = React.useState(false);
  const [showPop, setShowPop] = React.useState(false);
  const [updatePopUp, setUpdatePopUp] = React.useState(false);
  const [selectedConfigType, setSelectedConfigType] = React.useState(null);
  const [resourceCategoryData, setResourceCategoryData] = useState([]);
  const [modalData, setModalData] = useState();
  const [rowCount, setRowCount] = useState(0);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    getMasterDataAttr();
  }, []);

  const addUpdateHandler = (props) => {
    setUpdatePopUp(!updatePopUp);
    setModalData(props);
    setShowPop(false); // Close the add new modal if open
  };

  const addNewHandler = () => {
    setShowPop(!showPop);
  };

  useImperativeHandle(ref, () => ({
    refreshConfigMasterTable(configId) {
      setSelectedConfigType(configId);
      refreshConfigMasterTable(configId);
    },
  }));

  function showSuccessMsg(configId) {
    refreshConfigMasterTable(configId);
    toast.success("Master Data type added successfully.", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000, // Close after 2 seconds
    });
  }

  async function refreshConfigMasterTable(configId, sid = stateId) {
    var mastrDataList = await getData(getConfigsByCategoryName + configId + "?stateId=" + sid);
    mastrDataList.sort((a, b) => {
      return b.created_on - a.created_on;
    });
    setMasterTypeData(mastrDataList);
    setRowCount(mastrDataList.length);
  }
  async function getMasterDataAttr() {
    setLoader(true);
    const userProfile = await getData(getThemeURL);
        const state_id = userProfile[0]?.state_id;
        setStateId(state_id);
    var attrList = await getData(masterDataAttrTypeListURL.replace("STATEID",state_id));
    setLoader(false);
    for (let attr in attrList) {
      attrList[attr]["id"] = attrList[attr]["code"];
    }
    refreshConfigMasterTable(attrList[0].id, state_id);
    setSelectedConfigId(attrList[0].id);
    setResourceCategoryData(attrList);
  }

  async function getConfigDataByCode(event) {
    const value = event.target.value;
    if (!value) {
      // Placeholder selected — reset to the same default view shown on initial load
      setSelectedConfigType(null);
      const defaultConfigId = resourceCategoryData?.[0]?.id;
      if (defaultConfigId) {
        setSelectedConfigId(defaultConfigId);
        refreshConfigMasterTable(defaultConfigId);
      }
      return;
    }
    setSelectedConfigType(value);
    setSelectedConfigId(value);
    var mastrDataList = await getData(
      getConfigsByCategoryName + value + "?stateId=" + stateId
    );
    setMasterTypeData(mastrDataList);
    setRowCount(mastrDataList.length);
  }

  const columns = React.useMemo(
    () => [
      {
        Header: t("configurationmgttableheaders.value"),
        accessor: "value",
        leftAlign: true,
        disableSortBy: true,
      },
      {
        Header: t("configurationmgttableheaders.createdby"),
        accessor: "email",
        leftAlign: true,
        disableSortBy: true,
        Cell: (props) => {
          if (props.value && props.value != null) {
            let name = props.value;
            if (props.value.length > 15) {
              name = props.value.substring(0, 15) + "...";
            }
            return <span title={props.value}>{name}</span>;
          } else {
            return "SYSTEM";
          }
        },
      },
      {
        Header: t("configurationmgttableheaders.createdon"),
        accessor: "created_on",
        disableSortBy: true,
        Cell: (props) => {
          return <Moment format="DD/MM/YYYY, hh:mm A">{props.value}</Moment>;
        },
      },
      {
        Header: t("configurationmgttableheaders.updatedby"),
        accessor: "updated_by_email",
        leftAlign: true,
        disableSortBy: true,
        Cell: (props) => {
          if (props.value && props.value != null) {
            let name = props.value;
            if (props.value.length > 15) {
              name = props.value.substring(0, 15) + "...";
            }
            return <span title={props.value}>{name}</span>;
          } else {
            return "NA";
          }
        },
      },
      {
        Header: t("configurationmgttableheaders.updatedon"),
        accessor: "updatedOn",
        disableSortBy: true,
        Cell: (props) => {
          if (props.value) {
            return <Moment format="DD/MM/YYYY, hh:mm A">{props.value}</Moment>;
          } else {
            return "NA";
          }
        },
      },
      // {
      //   Header: "Status",
      //   accessor: "status",
      //   disableSortBy: true,
      //   Cell: (props) => {
      //     if(props.value === true){
      //       return "Active";
      //     }
      //     else{
      //       return "Inactive";
      //     }
      //   },
      // },
      // {
      //   Header: t("configurationmgttableheaders.action"),
      //   // accessor: "action",
      //   disableSortBy: true,

      //   Cell: (props) => {
      //     const [isdelete, setIsdelete] = useState(false);
      //     const deletePopUp = () => {
      //       setIsdelete(!isdelete);
      //     };
      //     const deleteTableDataById = async (id) => {
      //       let data = { id: id };
      //       var res = await putDataWithBody(deleteConfig, data, {});
      //       if (res.status == "success") {
      //         refreshConfigMasterTable(
      //           document.getElementById("config_type").value
      //         );
      //         toast.success(res.msg, {
      //           position: toast.POSITION.TOP_CENTER,
      //           autoClose: 2000, // Close after 2 seconds
      //         });
      //         setIsdelete(false);
      //       }
      //     };
      //     return (
      //       <div className="usertable__actionsicon">
      //         <Editicon
      //           onClick={() => addUpdateHandler(props.row.original)}
      //           value={props.value}
      //           className="cursor-pointer me-2"
      //         />

      //         {/* <span onClick={deletePopUp}>
      //           <Deleteicon
      //             value={props.value}
      //             className="cursor-pointer mr-1"
      //           />
      //         </span> */}

      //         {isdelete && (
      //           <Confirmpopup
      //             show={isdelete}
      //             title={t("deletepopuptext")}
      //             message={t("deletepopupmessage")}
      //             handleToggle={deletePopUp}
      //             row={props.row}
      //             name={props.row.original.value}
      //             deleteRow={deleteTableDataById}
      //             cancel={t("cancelbutton")}
      //             action={t("actionbutton")}
      //           />
      //         )}
      //       </div>
      //     );
      //   },
      // },
    ],
    [t]
  );

  const configColumnsForExport = React.useMemo(
    () => [
      { label: "Value", key: "value" },
      { label: "Created By", key: "email" },
      { label: "Created On", key: "created_on" },
      { label: "Updated By", key: "updated_by_email" },
      { label: "Updated On", key: "updatedOn" },
    ],
    []
  );

  return (
    <div className="create-user config-mgmt-table">
      <style>{`
        #light .config-mgmt-table .iccc--table th {
          background: linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%) !important;
          color: #ffffff !important;
        }
        #light .config-mgmt-table .add_config {
          background-color: #2E6DA4 !important;
          border-color: #2E6DA4 !important;
        }
        #light .config-mgmt-table .category__select {
          border: 1px solid #E4E7EC !important;
          color: #1D2939 !important;
        }
        #light .config-mgmt-table .iccc--table tbody tr td,
        #light .config-mgmt-table .iccc--table tbody tr th {
          border: none !important;
        }
        #light .config-mgmt-table .iccc--table tbody tr td {
          background-color: #fff !important;
        }
        #light .config-mgmt-table .iccc--table tbody tr:nth-child(even) td {
          background-color: #F9FAFB !important;
        }
        .config-mgmt-table .search-form {
          position: relative;
          display: inline-flex;
          align-items: center;
        }
        .config-mgmt-table .search-form input[type="text"] {
          height: 36px !important;
          line-height: 34px !important;
          padding: 0 40px 0 12px !important;
          border: 1px solid #E4E7EC !important;
          border-radius: 8px !important;
          font-size: 12px !important;
          box-sizing: border-box !important;
        }
        .config-mgmt-table .search-form button {
          position: absolute !important;
          top: 0 !important;
          bottom: 0 !important;
          right: 0 !important;
          height: 36px !important;
          width: 36px !important;
          margin: 0 !important;
          padding: 0 !important;
          background-color: transparent !important;
          border: none !important;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .config-mgmt-table .search-icon {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .config-mgmt-table .search-icon svg {
          display: block;
          color: #2E6DA4;
        }
      `}</style>
      <div
        style={{
          background: "#fff",
          border: "1px solid #EEF1F5",
          borderRadius: "10px",
          boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
          padding: "10px 14px",
          margin: "12px 12px 12px 12px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "10px" }}>
          <span
            style={{
              width: "20px",
              height: "20px",
              borderRadius: "6px",
              background: "#EBF4FA",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <FilterIcon size={11} color="#2E6DA4" />
          </span>
          <span style={{ fontSize: "12px", fontWeight: 800, color: "#2E6DA4" }}>Filters</span>
        </div>
        <div style={{ display: "flex", gap: "14px", flexWrap: "wrap", alignItems: "flex-end" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: "0 1 240px", maxWidth: "240px" }}>
            <label style={{ fontSize: "9.5px", fontWeight: 800, letterSpacing: ".3px", textTransform: "uppercase", color: "#98A2B3" }}>
              Agency Type
            </label>
            <SelectComponent
              id={"config_type"}
              value={selectedConfigType || ""}
              onChange={getConfigDataByCode}
              options={resourceCategoryData}
              showPlaceHolder="Select Agency Type"
              placeholderSelectable={true}
              style={{
                height: "36px",
                lineHeight: "34px",
                padding: "0 28px 0 12px",
                borderRadius: "8px",
                border: "1px solid #E4E7EC",
                fontSize: "12px",
                background: "#fff",
                color: "#1D2939",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          </div>
          <button
            className="btn btn-success btn-sm add_config"
            style={{ height: "36px", display: "flex", alignItems: "center", justifyContent: "center", boxSizing: "border-box" }}
            onClick={addNewHandler}>
            {t("configurationaddbuttonlabel")}
            {/* Add New */}
          </button>
        </div>
      </div>
      <div className="datatable__container config_data_tbl_container">

        {masterTypeData && (
          <Table
            className={"searchRsrcContainerTbl"}
            data={masterTypeData}
            columns={columns}
            numberOfRows={10}
            searchPlaceholder="Search by Value, Created By, Updated By"
            searchInputStyle={{ width: "19em" }}
            showExport={false}
            showExcelExport={true}
            exportData={masterTypeData}
            exportColumns={configColumnsForExport}
            exportFileName="ConfigurationManagement"
            showFilter={false}
            showReset={false}
            onExpand={false}
            rowCount={rowCount} // Pass rowCount to the Table component
            headerTableHeadStyle={{ background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)", color: "#FFFFFF" }}
            tableStyle={{
              border: "1px solid  #f0f0f0",
              borderRadius: "12px",
            }}
          />
        )}
        {showPop && (
          <ModalResourceType
            titleValue={t("popup.addnew")}
            showSuccessMsg={showSuccessMsg}
            selectedConfigId={selectedConfigId}
            show={showPop}
            buttonLabel={"popup.save"}
            handleToggle={addNewHandler}
            stateId={stateId}
            popupLabel={t("popup.addvalue")}
            {...props}
            configurationButton={true}
          />
        )}
        {updatePopUp && (
          <ModalResourceType
            data={modalData}
            titleValue={t("popup.configpopuptitle")}
            showSuccessMsg={showSuccessMsg}
            selectedConfigId={selectedConfigId}
            show={updatePopUp}
            buttonLabel={t("popup.update")}
            handleToggle={addUpdateHandler}
            popupLabel={t("popup.configpopuplabel")}
            stateId={stateId}
            {...props}
          />
        )}
      </div>
      {/* <Modal show={isShow}>
    return (
        <div className="container  create-user">
            <div className="datatable__container">
                <div className="ps-3 w-50 searchRsrcContainer d-flex float-start position-relative">
                    <SelectComponent
                    onChange={getConfigDataByCode}
                    classList={"me-2 w-50"}
                    options={resourceCategoryData}
                    />
                    <button className="btn btn-success btn-sm add_config" onClick={addNewHandler}>Add New</button>
                   
                </div>

                {masterTypeData && (
                    <Table
                        data={masterTypeData}
                        columns={columns}
                        numberOfRows={5}
                        showExport={false}
                        showFilter={false}
                        showReset={false}
                        onExpand={false}
                        headerTableHeadStyle={{ background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)", color: "#FFFFFF" }}
                        tableStyle={{ border: "none", padding: "0px" }}
                    />
                )}
                {showPop && <ModalResourceType 
                    titleValue={"Add New"}
                    showSuccessMsg={showSuccessMsg}
                    selectedConfigId={selectedConfigId} show={showPop}
                    handleToggle={addNewHandler}
                    popupLabel= "Value"
                    {...props} />}
            </div>
            {/* <Modal show={isShow}>
                <Modal.Header closeButton onClick={hideModal}>
                    <Modal.Title>Alert !</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure, you want to delete the role ?</Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="danger"
                        className="delete_user_btn"
                        // onClick={hideModal}
                    >
                        Cancel
                    </Button>
                    <Button
                        // onClick={deleteRoleByRoleId}
                        variant="dark"
                        className="create_user_btn"
                    >
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal> */}
    </div>
  );
});

export default MasterDataTable;
